import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedText } from 'core/i18n';
import IdentificationCard from 'components/identificationCard';
// @ Constants
import { CREDIT_CARD, TRADITIONAL } from 'constants/userProfile';

const DOCUMENTATION_TEXT_KEYS = {
    [TRADITIONAL]: 'documentation-identificationCardDocumentacion',
    [CREDIT_CARD]: 'documentation-identificationCardCreditCardDocumentacion',
};

class DocumentationCard extends Component {
    constructor(props) {
        super(props);
    }

    render = () => {
        const { documentation, userProfile } = this.props;
        const documentationTextKeyByInvestmentType = DOCUMENTATION_TEXT_KEYS[userProfile.investmentType];
        const key = documentationTextKeyByInvestmentType
            ? documentationTextKeyByInvestmentType
            : DOCUMENTATION_TEXT_KEYS[TRADITIONAL];

        if (documentation.size === 0) return null;

        return (
            <IdentificationCard
                icon="documentacion"
                className="identification-card-container identification-card-container-documentacion"
                iconClassName="identification-card-icon-documentacion"
                contentClassName="identification-card-content-documentacion"
            >
                <FormattedText value={key} />
            </IdentificationCard>
        );
    };
}

export default connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        products: state.products,
    }),
    {}
)(DocumentationCard);
